import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import {
  RideGrid,
  RideButton,
  RideGlTelephoneSolid,
  RideLink,
} from '@rimac-seguros/ride-system-components';
import { getParameterValue } from '../../../utils/helpers';

import { useVisibilityElement } from '../../../hooks/useVisibilityElement';
import useBreakpoint from '../../../hooks/useBreakpoint';
import { getTagActionName } from '../../../utils/analytics';
import { useAppContext } from '../../../AppProvider';

import './styles.scss';

const RbrHeader = ({ authoring }) => {
  const {
    srcHeader,
    altHeader,
    title,
    telephone,
  } = authoring;

  const [isScrolled, setIsScrolled] = useState(false);

  const { isVisible: isVisibleHero } = useVisibilityElement('section-hero');
  const isDesktop = useBreakpoint('large-min');
  const location = useLocation();
  const { state: { experiments } } = useAppContext();
  const isStepInitial = location.pathname === '/comprar/seguro-salud-flexible';
  const { experimentCyber } = experiments;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClickQuote = () => {
    if (!isVisibleHero) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Fixed', 'trackAction');
    }
  };

  // Fix temporal: incorrecto funcionamiento de boton de telefono en mobile
  const hidePhone = getParameterValue('mcid')?.includes('app:referral');
  if (hidePhone) sessionStorage.setItem('__hidePhone', 'true');
  const customClass = experimentCyber?.isActive || !isStepInitial ? 'relative' : 'sticky z-20 md:z-[60]';

  return (
    <div
      id="section-header"
      className={`container-header ${
        isScrolled && !isVisibleHero && isStepInitial ? 'shadow-ride-gl-shadow-moderate' : ''
      } ${customClass} ${experiments?.campaignDays || experimentCyber?.isActive ? 'mt-additional-banner' : ''}`}
    >
      <RideGrid>
        <div
          className={`container-header_content ${
            !isVisibleHero && isStepInitial ? 'is-hidden-header' : ''
          }`}
        >
          <div className="container-header_left">
            <img src={srcHeader} alt={altHeader} />
            <span>{title}</span>
          </div>
          <div className="container-header_right">
            {isStepInitial && (
              <>
                <div className="container-header_right--contact">
                  <p>Compra con un asesor</p>
                  <RideLink
                    text={telephone}
                    href={`tel:${telephone}`}
                    target="_blank"
                    variant="secondary"
                    glyph={<RideGlTelephoneSolid />}
                    glyphPosition="left"
                    size="large"
                  />
                </div>
                <RideButton
                  text="Cotizar ahora"
                  size={isDesktop ? 'x-large' : 'small'}
                  onClick={handleClickQuote}
                />
              </>
            )}
          </div>
        </div>
      </RideGrid>
    </div>
  );
};

RbrHeader.propTypes = {
  authoring: PropTypes.shape({
    srcHeader: PropTypes.string.isRequired,
    altHeader: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    telephone: PropTypes.string.isRequired,
  }).isRequired,
};

export default RbrHeader;
